import { render, staticRenderFns } from "./EducationNicheIcon.vue?vue&type=template&id=3fee75ae&scoped=true"
import script from "./EducationNicheIcon.vue?vue&type=script&lang=js"
export * from "./EducationNicheIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fee75ae",
  null
  
)

export default component.exports